import { createFileRoute } from '@tanstack/react-router'
import { MetricRepositoriesProvider } from '_/features/metrics/ui/contexts/metric-repositories-provider'
import { MetricsPage } from '_/features/metrics/ui/pages/metrics-page'

const MetricsRoute = () => (
	<MetricRepositoriesProvider>
		<MetricsPage />
	</MetricRepositoriesProvider>
)

export const Route = createFileRoute('/_authenticated/metrics')({
	staticData: { title: 'metrics_title' },
	component: MetricsRoute,
})
